<template>
  <div class="forgot-password__container">
    <template v-if="step === 'before-request'">
      <loader-spinner v-if="loading" />
      <template v-else>
        <h2>Get Help Signing Into Your Account</h2>
        <p>
          Enter the email address you use for this account. We will email you instructions on how to
          reset your password.
        </p>
        <form class="mds-form mds-form--large-layout" method="post" action="">
          <fieldset class="mds-form__fieldset">
            <div class="mds-form__field-group">
              <div class="mds-form__field">
                <label class="mds-form__label" for="email">
                  Email
                  <abbr
                    class="mds-form__label-required-indicator"
                    title="This field is required."
                    aria-hidden="true"
                    >*</abbr
                  >
                  <span class="mds-form__label-required-indicator-label">Required Field.</span>
                </label>
                <input class="mds-form__input" type="email" id="email" v-model="email" />
              </div>
            </div>
            <div class="mds-form__field-group">
              <button class="mds-button mds-button--secondary" type="button" @click="cancel">
                Cancel
              </button>
              <button class="mds-button mds-button--primary" type="button" @click="secureSubmit">
                Submit
              </button>
            </div>
            <div v-if="error" class="mds-form__field-group mds-form--error">
              <span class="mds-form__field-error" role="alert">
                <span class="mds-form__field-error-text"> Email is a required field</span>
              </span>
            </div>
          </fieldset>
        </form>
      </template>
    </template>
    <template v-if="step === 'after-request'">
      <h2>Check Your Email</h2>
      <p>We sent a verification for your security. It might take a few minutes to arrive.</p>
      <div class="mds-form__field-group">
        <label class="mds-form__label">We sent it to:</label>
        <p>{{ this.email | masked }}</p>
      </div>
      <p>
        Didn’t get it?
        <a href="javascript:void(0)" class="mds-link" @click="tryAgain">
          Try again
        </a>
      </p>
      <div class="mds-form__field-group">
        <button class="mds-button mds-button--primary" type="button" @click="cancel">
          Return to Login
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import reCaptchaMixin from '@/mixins/ReCaptchaMixin';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
// ToDo: We are not using this page, should be removed
export default {
  name: 'forgot-password',
  components: {
    LoaderSpinner,
  },
  mixins: [reCaptchaMixin()],
  data() {
    return {
      email: '',
      error: false,
      loading: false,
      step: 'before-request',
    };
  },
  filters: {
    masked(value) {
      const [username, domain] = value.split('@');
      const mask = Array(username.length).join('*');
      return `${username.charAt(0)}${mask}@${domain}`;
    },
  },
  methods: {
    async secureSubmit() {
      /**
       * {
       *  result: boolean
       *  token: String
       * }
       */
      const response = await this.reCaptcha();
      if (response && response.result) {
        return this.submit();
      }
      return null;
    },
    submit() {
      if (this.email) {
        this.error = false;
        this.loading = true;

        const payload = {
          emailAddress: this.email,
        };

        const url = `${process.env.VUE_APP_ACTUAL_API_URL}/users/passwords/forgot-request`;
        this.$request
          .fetch(url, {
            method: 'post',
            body: JSON.stringify(payload),
          })
          .then((response) => {
            this.loading = false;
            this.step = 'after-request';
            return response;
          })
          .catch((err) => {
            if (err.status === 401) {
              this.$router.push('/Login');
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
      }
    },
    cancel() {
      this.$emit('jumpTo', 'login');
    },
    tryAgain() {
      this.email = '';
      this.step = 'before-request';
    },
  },
};
</script>
<style lang="scss" scoped>
.mds-form__field-group {
  @include fc-buttons-list();
}
</style>>
